export default __webpack_public_path__ + "static/media/1123test.59b27acc.png";